import React, { useState, useEffect } from "react";
import "react-tabs/style/react-tabs.css";
import { faBars, faSearch, faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../ventas-ordenes/VentasOrdenes.css";
import ReactDOM from "react-dom";
import {
  Document,
  Font,
  Image,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import {
  Table,
  Form,
  Pagination,
  Button,
  Modal,
  Row,
  Col,
} from "react-bootstrap";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { projectFirestore } from "../../../../firebase/config";

export default function HistorialCajas() {
  const { register } = useAuthContext();
  const [data, setData] = useState([]);
  const [sortType, setSortType] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterText, setFilterText] = useState("");
  const elementsPerPage = 7;
  const [dateRange, setDateRange] = useState([]);
  const [entradas, setEntradas] = useState([]);
  const [salidas, setSalidas] = useState([]);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [detalleOrden, setDetalleOrden] = useState([]);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp.seconds * 1000);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    const turno = date.getHours() >= 12 ? "PM" : "AM";
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    const Semana = Math.ceil(
      ((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7
    );
    return {
      date: formattedDate, // Retorna la fecha formateada
      time: formattedTime, // Retorna la hora formateada
      mes: date.toLocaleString("es-MX", { month: "long" }).toUpperCase(),
      año: date.getFullYear(),
      turno: turno,
      semana: Semana,
    };
  };

  const customModalInfoStyles = {
    content: {
      width: "600px",
      height: "200px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };

  const handleDateRangeChange = (dateRangeP) => {
    setDateRange({ dateRange: dateRangeP });
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  const filteredData = data.filter((item) => {
    const date = new Date(item.fecha.seconds * 1000);
    if (dateRange && dateRange.dateRange && filterText !== "") {
      return (
        filterText !== "" &&
        item.id_empleado &&
        item.id_empleado
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) &&
        date >= dateRange.dateRange[0] &&
        date <= dateRange.dateRange[1]
      );
    } else if (dateRange && dateRange.dateRange) {
      return date >= dateRange.dateRange[0] && date <= dateRange.dateRange[1];
    } else if (filterText !== "") {
      return (
        item.id_empleado &&
        item.id_empleado
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase())
      );
    } else {
      return true;
    }
  });

  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  //#region PDF Ticket

  Font.register({
    family: "Oswald",
    src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
  });

  const styles = StyleSheet.create({
    body: {
      paddingTop: 20,
      paddingBottom: 20,
      paddingHorizontal: 20,
    },
    title: {
      fontSize: 6.5,
      textAlign: "center",
      fontFamily: "Oswald",
    },
    author: {
      fontSize: 3,
      textAlign: "center",
      marginBottom: 40,
    },
    subtitle: {
      fontSize: 6.5,
      textAlign: "center",
      fontFamily: "Oswald",
    },
    text: {
      fontSize: 5.5,
      textAlign: "center",
      fontFamily: "Oswald",
    },
    image: {
      width: 37,
      height: 17,
    },
    row: {
      flexDirection: "row",
    },
    titleprod: {
      flex: 3,
      fontSize: 5.5,
      textAlign: "center",
      margin: 0,
      padding: 0,
      flexGrow: 3,
    },
    titletrow: {
      flex: 1,
      margin: 0,
      fontSize: 5.5,
      padding: 3,
      flexGrow: 3,
    },
    contentrow: {
      flex: 1,
      fontSize: 5.5,
      textAlign: "right",
      margin: 0,
      padding: 3,
      flexGrow: 1,
    },
    header: {
      fontSize: 4,
      marginBottom: 20,
      textAlign: "center",
      color: "grey",
    },
  });

  const App = () => (
    <PDFViewer className="PDFViewer">
      <MyDocument />
    </PDFViewer>
  );

  const MyDocument = () => (
    <Document>
      <Page size={[227, 610]} style={styles.body}>
        <View style={styles.row}>
          <Image
            alt=""
            src={register.imgticket ? register.imgticket : register.img}
            style={{ width: 37, height: 25 }}
          ></Image>
          <View style={styles.contentrow}>
            <Text style={styles.title}>{register.nameticket}</Text>
            <Text style={styles.title}>
              {register.razon_socialticket
                ? "Razon social: " + register.razon_social
                : ""}
            </Text>
            <Text style={styles.title}>
              {register.calleticket
                ? register.calleticket +
                  " #" +
                  register.numdomticket +
                  " Col." +
                  register.coloniaticket +
                  " C.P. " +
                  register.codigopticket
                : ""}
            </Text>
            <Text style={styles.title}>
              {register.municipioticket
                ? register.municipioticket +
                  ", " +
                  register.estadoticket +
                  " " +
                  register.paisticket
                : ""}
            </Text>
            <Text style={styles.subtitle}>
              {register.sucursalticket
                ? "Sucursal:" + register.sucursalticket
                : ""}
            </Text>
            <Text style={styles.subtitle}>
              {register.rfcticket ? "RFC:" + register.rfcticket : ""}
            </Text>
            <Text style={styles.subtitle}>
              {register.phoneticket ? "Telefono: " + register.phoneticket : ""}
            </Text>
          </View>
          <Image
            src="/static/media/logonaranja.47703c147962eb0583b9.png"
            style={[styles.image]}
          ></Image>
        </View>
        <View style={styles.row}>
          <Text
            style={[styles.contentrow, { textAlign: "right", paddingTop: 10 }]}
          >
            Fecha y hora:{" "}
            {detalleOrden.fechaCierre
              ? formatTimestamp(detalleOrden.fechaCierre).date +
                " " +
                formatTimestamp(detalleOrden.fechaCierre).time
              : ""}
          </Text>
        </View>
        <Text style={{ paddingBottom: 5, fontSize: 5.5 }}>
          Empleado:{" "}
          {detalleOrden.id_empleado !== ""
            ? detalleOrden.id_empleado
            : "Administrador"}
        </Text>
        #region Total en caja
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Total en caja</Text>
          </View>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Fondo inicial:
            </Text>
            <Text style={styles.contentrow}>
              ${detalleOrden.fondo ? detalleOrden.fondo.toFixed(2) : "0.00"} MXN{" "}
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de ventas en efectivo
            </Text>
            <Text style={styles.contentrow}>
              $
              {detalleOrden.totalEfectivo ? detalleOrden.totalEfectivo : "0.00"}{" "}
              MXN{" "}
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de entradas
            </Text>
            <Text style={styles.contentrow}>
              $
              {entradas
                ? entradas
                    .reduce((acom, num) => {
                      return acom + num.monto;
                    }, 0)
                    .toFixed(2)
                : "0.00"}{" "}
              MXN
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de salidas
            </Text>
            <Text style={styles.contentrow}>
              -$
              {salidas
                ? salidas
                    .reduce((acom, num) => {
                      return acom + num.monto;
                    }, 0)
                    .toFixed(2)
                : "0.00"}{" "}
              MXN
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Devoluciones de efectivo
            </Text>
            <Text style={styles.contentrow}>
              -$
              {detalleOrden.totalCancelacionesEfectivo
                ? detalleOrden.totalCancelacionesEfectivo
                : "0.00"}{" "}
              MXN
            </Text>
          </View>
        </>
        <View style={styles.row}>
          <Text style={styles.contentrow}>
            ---------------------------------------------------------------------------------------------------------------
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.titletrow}></Text>
          <Text style={styles.contentrow}>Total:</Text>
          <Text style={styles.contentrow}>
            $
            {(
              parseFloat(detalleOrden.fondo) +
              parseFloat(detalleOrden.totalEfectivo) -
              parseFloat(salidas.reduce((acom, num) => acom + num.monto, 0)) +
              parseFloat(entradas.reduce((acom, num) => acom + num.monto, 0)) -
              parseFloat(
                detalleOrden.totalCancelacionesEfectivo
                  ? detalleOrden.totalCancelacionesEfectivo
                  : 0
              )
            ).toFixed(2)}{" "}
            MXN
          </Text>
        </View>
        #endregion #region Total de ventas
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Total de ventas</Text>
          </View>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de ventas en efectivo
            </Text>
            <Text style={styles.contentrow}>
              $
              {detalleOrden.totalEfectivo ? detalleOrden.totalEfectivo : "0.00"}{" "}
              MXN{" "}
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de ventas con tarjeta
            </Text>
            <Text style={styles.contentrow}>
              ${detalleOrden.totalTarjeta ? detalleOrden.totalTarjeta : "0.00"}{" "}
              MXN{" "}
            </Text>
          </View>
        </>
        <>
          <View style={styles.row}></View>
          <View style={styles.row}>
            <Text style={styles.titletrow} fixed>
              Total de cancelaciones/devoluciones
            </Text>
            <Text style={styles.contentrow}>
              -$
              {detalleOrden.totalCancelaciones
                ? detalleOrden.totalCancelaciones
                : "0.00"}{" "}
              MXN
            </Text>
          </View>
        </>
        <View style={styles.row}>
          <Text style={styles.contentrow}>
            ---------------------------------------------------------------------------------------------------------------
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.titletrow}></Text>
          <Text style={styles.contentrow}>Total:</Text>
          <Text style={styles.contentrow}>
            $
            {(
              parseFloat(detalleOrden.totalTarjeta) +
              parseFloat(detalleOrden.totalEfectivo) -
              parseFloat(
                detalleOrden.totalCancelaciones
                  ? detalleOrden.totalCancelaciones
                  : 0
              )
            ).toFixed(2)}{" "}
            MXN
          </Text>
        </View>
        #endregion #region Entradas
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Total de entradas</Text>
          </View>
          {entradas.map((ent) => (
            <>
              <View style={styles.row}></View>
              <View style={styles.row}>
                <Text style={styles.titletrow} fixed>
                  {ent.descripcion}
                </Text>
                <Text style={styles.contentrow}>
                  ${ent.monto.toFixed(2)} MXN
                </Text>
              </View>
            </>
          ))}
        </>
        <View style={styles.row}>
          <Text style={styles.contentrow}>
            ---------------------------------------------------------------------------------------------------------------
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.titletrow}></Text>
          <Text style={styles.contentrow}>Total:</Text>
          <Text style={styles.contentrow}>
            $
            {entradas
              ? entradas.reduce((acom, num) => acom + num.monto, 0).toFixed(2)
              : "0.00"}{" "}
            MXN
          </Text>
        </View>
        #endregion #region Salidas
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Total de salidas</Text>
          </View>
          {salidas.map((ent) => (
            <>
              <View style={styles.row}></View>
              <View style={styles.row}>
                <Text style={styles.titletrow} fixed>
                  {ent.descripcion}
                </Text>
                <Text style={styles.contentrow}>
                  ${ent.monto.toFixed(2)} MXN
                </Text>
              </View>
            </>
          ))}
        </>
        <View style={styles.row}>
          <Text style={styles.contentrow}>
            ---------------------------------------------------------------------------------------------------------------
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.titletrow}></Text>
          <Text style={styles.contentrow}>Total:</Text>
          <Text style={styles.contentrow}>
            $
            {salidas
              ? salidas.reduce((acom, num) => acom + num.monto, 0).toFixed(2)
              : "0.00"}{" "}
            MXN
          </Text>
        </View>
        #endregion #region Puntos
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>Puntos</Text>
          </View>
          <>
            <View style={styles.row}></View>
            <View style={styles.row}>
              <Text style={styles.titletrow} fixed>
                Puntos canjeados
              </Text>
              <Text style={styles.contentrow}>
                {detalleOrden.puntosCanjeados
                  ? detalleOrden.puntosCanjeados
                  : "0"}{" "}
                puntos
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.titletrow} fixed>
                Puntos otorgados
              </Text>
              <Text style={styles.contentrow}>
                {detalleOrden.puntosOtorgados
                  ? detalleOrden.puntosOtorgados
                  : "0"}{" "}
                puntos
              </Text>
            </View>
          </>
        </>
        #endregion #region Puntos
        <>
          <View style={styles.row}>
            <Text style={styles.titleprod}>MercadoPago</Text>
          </View>
          <>
            <View style={styles.row}></View>
            <View style={styles.row}>
              <Text style={styles.titletrow} fixed>
                Total de ventas con MercadoPago
              </Text>
              <Text style={styles.contentrow}>
                $
                {detalleOrden.totalMercadoPago
                  ? detalleOrden.totalMercadoPago
                  : "0.00"}{" "}
                MXN
              </Text>
            </View>
          </>
        </>
        #endregion
      </Page>
    </Document>
  );

  const Imprimir = () => {
    var myWindow = window.open("", "MsgWindow");
    myWindow.document.write(
      '<html><head><title>Ticket de venta</title><link rel="icon" href="/favicon.ico"><style type="text/css">html, body, div, iframe { margin:0; padding:0; height:100%; }iframe { display:block; width:100%; border:none; }</style></head><body>'
    );
    myWindow.document.write("</body></html>");
    ReactDOM.render(<App />, myWindow.document.body);
  };
  //#endregion

  async function mostrarDetalles(item) {
    setDetalleOrden(item);
    const q = query(collection(projectFirestore, "cajas", item.id, "entradas"));
    const querySnapshot = await getDocs(q);
    const entradasData = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      data.id = doc.id;
      entradasData.push(data);
    });
    setEntradas(entradasData);
    const q2 = query(collection(projectFirestore, "cajas", item.id, "salidas"));
    const querySnapshot2 = await getDocs(q2);
    const salidasData = [];
    querySnapshot2.forEach((doc) => {
      const data = doc.data();
      data.id = doc.id;
      salidasData.push(data);
    });
    setSalidas(salidasData);
    setMostrarDetalle(true);
  }

  useEffect(() => {
    const filtros = [{ campo: "puesto", operador: "==", valor: register.id }];
    let q = query(collection(projectFirestore, "cajas"));
    filtros.forEach((filtro) => {
      const { campo, operador, valor } = filtro;
      q = query(q, where(campo, operador, valor));
    });
    q = query(q, orderBy("fecha", "desc"));
    onSnapshot(q, (docs) => {
      const documentosColeccion = [];
      docs.docs.forEach((docu) => {
        const data = docu.data();
        data.id = docu.id;
        if (data.id_empleado !== "") {
          let dataP = getDoc(
            doc(collection(projectFirestore, "personal"), data.id_empleado)
          );
          dataP.then((docu) => {
            if (docu.exists()) {
              let dataU = getDoc(
                doc(
                  collection(projectFirestore, "users"),
                  docu.data().id_usuario
                )
              );
              dataU.then((docUser) => {
                if (docUser.exists()) {
                  data.id_empleado = docUser.data().fullName;
                } else {
                  data.id_empleado = "Usuario no encontrado";
                }
                setData((prevData) => {
                  return [...prevData, data];
                });
              });
            }
          });
        }
        documentosColeccion.push(data);
      });
      setData(documentosColeccion);
    });
  }, [register.id]);

  // async function cierreCajas() {
  //   const filtros = [{ campo: "puesto", operador: "==", valor: register.id }];
  // }

  return (
    <div>
      <br />
      <br />
      <br />
      <div className="container">
        <>
          <h4 className="page-title">HISTORIAL DE CAJAS</h4>
          <div className="mrg-titulo mrg-tbl"></div>
          <div className="row">
            <div className="col-sm-3">
              <div className="input-group">
                <Form.Control
                  className="form-control border-end-0 border rounded-pill"
                  type="text"
                  aria-describedby="search-icon"
                  placeholder="Busqueda general"
                  value={filterText}
                  onChange={handleFilterTextChange}
                />
                <span className="input-group-append">
                  <button
                    className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                    type="button"
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </button>
                </span>
              </div>
            </div>

            <div className="col-sm-3">
              <div className="input-group">
                <DateRangePicker
                  appearance="default"
                  placeholder="Filtar por rango de fechas"
                  onChange={handleDateRangeChange}
                  style={{ width: 230 }}
                />
              </div>
            </div>
            <div className="col-lg-12 mrg-tbl">
              <Table striped bordered hover border="2">
                <thead>
                  <tr>
                    <th
                      onClick={() =>
                        setSortType(sortType === "asc" ? "desc" : "asc")
                      }
                    >
                      {" "}
                      <FontAwesomeIcon icon={faSort} /> Fecha de apertura
                    </th>
                    <th>Fecha de cierre</th>
                    <th>Empleado</th>
                    <th>Fondo inicial</th>
                    <th>Total en caja</th>
                    <th>Total en efectivo</th>
                    <th>Total de entradas</th>
                    <th>Total de salidas</th>
                    <th>Total con tarjeta</th>
                    <th>Tipo de cambio</th>
                    <th>Detalles</th>
                  </tr>
                </thead>
                <tbody>
                  {getElementsForPage(currentPage)
                    .sort()
                    .map((val, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            {formatTimestamp(val.fecha).date}{" "}
                            {formatTimestamp(val.fecha).time}{" "}
                          </td>
                          <td>
                            {val.fechaCierre
                              ? formatTimestamp(val.fechaCierre).date +
                                " " +
                                formatTimestamp(val.fechaCierre).time +
                                " "
                              : ""}{" "}
                          </td>
                          <td>
                            {val.id_empleado !== ""
                              ? val.id_empleado
                              : "Administrador"}
                          </td>
                          <td>
                            {"$"}
                            {val.fondo
                              ? parseFloat(val.fondo).toFixed(2)
                              : "0.00"}
                          </td>
                          <td>
                            {"$"}
                            {val.totalCaja
                              ? parseFloat(val.totalCaja).toFixed(2)
                              : "0.00"}
                          </td>
                          <td>
                            {"$"}
                            {val.totalEfectivo
                              ? parseFloat(val.totalEfectivo).toFixed(2)
                              : "0.00"}
                          </td>
                          <td>
                            {"$"}
                            {val.totalEntradas
                              ? parseFloat(val.totalEntradas).toFixed(2)
                              : "0.00"}
                          </td>
                          <td>
                            {"$"}
                            {val.totalSalidas
                              ? parseFloat(val.totalSalidas).toFixed(2)
                              : "0.00"}
                          </td>
                          <td>
                            {"$"}
                            {val.totalTarjeta
                              ? parseFloat(val.totalTarjeta).toFixed(2)
                              : "0.00"}
                          </td>
                          <td>
                            {"$"}
                            {val.tipocambio
                              ? parseFloat(val.tipocambio).toFixed(2)
                              : "0.00"}
                          </td>
                          <td>
                            <Button
                              variant="primary"
                              style={{
                                minWidth: "50px !important",
                                marginLeft: 20,
                              }}
                              onClick={() => {
                                mostrarDetalles(val);
                              }}
                            >
                              <FontAwesomeIcon icon={faBars} />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              <Pagination>
                {Array.from({
                  length: Math.ceil(filteredData.length / elementsPerPage),
                }).map((page, index) => (
                  <Pagination.Item
                    key={index}
                    active={index + 1 === currentPage}
                    className={index + 1 === currentPage ? "btn-paginado" : ""}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </div>
          </div>
        </>
      </div>
      <Modal
        style={customModalInfoStyles}
        size="xl"
        show={mostrarDetalle}
        onHide={() => setMostrarDetalle(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Resumen de caja del{" "}
            {detalleOrden.fecha ? formatTimestamp(detalleOrden.fecha).date : ""}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <h3>
                Empleado:{" "}
                {detalleOrden.id_empleado !== ""
                  ? detalleOrden.id_empleado
                  : "Administrador"}
              </h3>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <h5>
                Apertura:{" "}
                {detalleOrden.fecha
                  ? formatTimestamp(detalleOrden.fecha).date +
                    " " +
                    formatTimestamp(detalleOrden.fecha).time +
                    " "
                  : ""}
              </h5>
              <h5>
                Corte:{" "}
                {detalleOrden.fechaCierre
                  ? formatTimestamp(detalleOrden.fechaCierre).date +
                    " " +
                    formatTimestamp(detalleOrden.fechaCierre).time +
                    " "
                  : ""}
              </h5>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={7}>
              <>
                <Row style={{ marginBottom: "20px", textAlign: "center" }}>
                  <h2>Total en caja</h2>
                </Row>
                <Row>
                  <Col md={8}>
                    <h6>Fondo inicial: </h6>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h6>
                      $
                      {detalleOrden.fondo
                        ? parseFloat(detalleOrden.fondo).toFixed(2)
                        : "0.00"}{" "}
                      MXN
                    </h6>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <h6>Total de ventas en Efectivo: </h6>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h6>
                      $
                      {detalleOrden.totalEfectivo
                        ? detalleOrden.totalEfectivo
                        : "0.00"}{" "}
                      MXN
                    </h6>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <h6>Total de entradas: </h6>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h6>
                      $
                      {entradas
                        ? entradas
                            .reduce((acom, num) => {
                              return acom + num.monto;
                            }, 0)
                            .toFixed(2)
                        : "0.00"}{" "}
                      MXN
                    </h6>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <h6>Total de salidas: </h6>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h6>
                      -$
                      {salidas
                        ? salidas
                            .reduce((acom, num) => {
                              return acom + num.monto;
                            }, 0)
                            .toFixed(2)
                        : "0.00"}{" "}
                      MXN
                    </h6>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <h6>Total de cancelaciones/devoluciones: </h6>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h6>
                      -$
                      {detalleOrden.totalCancelacionesEfectivo
                        ? detalleOrden.totalCancelacionesEfectivo
                        : "0.00"}{" "}
                      MXN
                    </h6>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col md={8}>
                    <h5>Total en caja: </h5>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h5>
                      $
                      {(
                        parseFloat(
                          detalleOrden.fondo ? detalleOrden.fondo : 0
                        ) +
                        parseFloat(
                          detalleOrden.totalEfectivo
                            ? detalleOrden.totalEfectivo
                            : 0
                        ) -
                        parseFloat(
                          salidas.reduce((acom, num) => acom + num.monto, 0)
                        ) +
                        parseFloat(
                          entradas.reduce((acom, num) => acom + num.monto, 0)
                        ) -
                        parseFloat(
                          detalleOrden.totalCancelaciones
                            ? detalleOrden.totalCancelaciones
                            : 0
                        )
                      ).toFixed(2)}{" "}
                      MXN
                    </h5>
                  </Col>
                </Row>
              </>
              <>
                <Row style={{ marginBottom: "20px", textAlign: "center" }}>
                  <h2>Total de ventas</h2>
                </Row>
                <Row>
                  <Col md={8}>
                    <h6>Total de ventas en Efectivo: </h6>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h6>
                      $
                      {detalleOrden.totalEfectivo
                        ? detalleOrden.totalEfectivo
                        : "0.00"}{" "}
                      MXN
                    </h6>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <h6>Total de ventas con tarjeta: </h6>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h6>
                      $
                      {detalleOrden.totalTarjeta
                        ? detalleOrden.totalTarjeta
                        : "0.00"}{" "}
                      MXN
                    </h6>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <h6>Total de cancelaciones/devoluciones: </h6>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h6>
                      -$
                      {detalleOrden.totalCancelaciones
                        ? detalleOrden.totalCancelaciones
                        : "0.00"}{" "}
                      MXN
                    </h6>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col md={8}>
                    <h5>Total: </h5>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    <h5>
                      $
                      {(
                        parseFloat(
                          detalleOrden.totalEfectivo
                            ? detalleOrden.totalEfectivo
                            : 0
                        ) +
                        parseFloat(
                          detalleOrden.totalTarjeta
                            ? detalleOrden.totalTarjeta
                            : 0
                        ) -
                        parseFloat(
                          detalleOrden.totalCancelaciones
                            ? detalleOrden.totalCancelaciones
                            : 0
                        )
                      ).toFixed(2)}{" "}
                      MXN
                    </h5>
                  </Col>
                </Row>
              </>
            </Col>
            <Col md={5}>
              <Row>
                <Col md={12}>
                  <h3 style={{ textAlign: "center" }}>Entradas </h3>
                </Col>
                <Col md={12}>
                  {entradas
                    .filter((e) => {
                      return e.monto !== 0;
                    })
                    .map((ent) => (
                      <Row>
                        <Col md={3} style={{ textAlign: "left" }} key={ent.id}>
                          <h6>
                            {ent.fecha ? formatTimestamp(ent.fecha).time : ""}
                          </h6>
                        </Col>
                        <Col md={5} key={ent.id}>
                          <h6>{ent.descripcion}</h6>
                        </Col>
                        <Col md={4} style={{ textAlign: "right" }}>
                          <h6>${ent.monto.toFixed(2)} MXN</h6>
                        </Col>
                      </Row>
                    ))}
                  <hr />
                  <Row>
                    <Col md={8} style={{ textAlign: "left" }}>
                      <h6>Total: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>
                        $
                        {entradas
                          ? entradas
                              .reduce((acom, num) => acom + num.monto, 0)
                              .toFixed(2)
                          : "0.00"}{" "}
                        MXN
                      </h6>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br />
              <br />
              <Row>
                <Col md={12}>
                  <h3 style={{ textAlign: "center" }}>Salidas </h3>
                </Col>
                <Col md={12}>
                  {salidas
                    .filter((e) => {
                      return e.monto !== 0;
                    })
                    .map((ent) => (
                      <Row>
                        <Col md={3} style={{ textAlign: "left" }} key={ent.id}>
                          <h6>{formatTimestamp(ent.fecha).time}</h6>
                        </Col>
                        <Col md={5} key={ent.id}>
                          <h6>{ent.descripcion}</h6>
                        </Col>
                        <Col md={4} style={{ textAlign: "right" }}>
                          <h6>${ent.monto.toFixed(2)} MXN</h6>
                        </Col>
                      </Row>
                    ))}
                  <hr />
                  <Row>
                    <Col md={8} style={{ textAlign: "left" }}>
                      <h6>Total: </h6>
                    </Col>
                    <Col md={4} style={{ textAlign: "right" }}>
                      <h6>
                        $
                        {salidas
                          ? salidas
                              .reduce((acom, num) => acom + num.monto, 0)
                              .toFixed(2)
                          : "0.00"}{" "}
                        MXN
                      </h6>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <h3 style={{ textAlign: "center" }}>Puntos</h3>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col md={7} style={{ textAlign: "left" }}>
                      <h6>Total de puntos canjeados: </h6>
                    </Col>
                    <Col md={5} style={{ textAlign: "right" }}>
                      <h6>
                        {detalleOrden.puntosCanjeados
                          ? detalleOrden.puntosCanjeados
                          : 0}{" "}
                        puntos
                      </h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={7} style={{ textAlign: "left" }}>
                      <h6>Total de puntos otorgados: </h6>
                    </Col>
                    <Col md={5} style={{ textAlign: "right" }}>
                      <h6>
                        {detalleOrden.puntosOtorgados
                          ? detalleOrden.puntosOtorgados
                          : 0}{" "}
                        puntos
                      </h6>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={12}>
                  <h3 style={{ textAlign: "center" }}>MercadoPago</h3>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col md={7} style={{ textAlign: "left" }}>
                      <h6>Total de ventas con MercadoPago: </h6>
                    </Col>
                    <Col md={5} style={{ textAlign: "right" }}>
                      <h6>
                        $
                        {detalleOrden.totalMercadoPago
                          ? detalleOrden.totalMercadoPago
                          : "0.00"}{" "}
                        MXN
                      </h6>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "space-between" }}>
          <div>
            <button onClick={Imprimir} className="newbutton-style filled">
              Imprimir ticket
            </button>
            {/* <button
              // onClick={saveRegistro}
              className="newbutton-style filled"
            >
              Exportar a excel
            </button> */}
          </div>
          <div>
            <button
              onClick={() => setMostrarDetalle(false)}
              className="newbutton-style non-filled-text"
              style={{ backgroundColor: "#FFFFFF", color: "#000" }}
            >
              Cerrar
            </button>
            {/* <button
              onClick={(e) => {
                setMostrarDetalle(false);
              }}
              className="newbutton-style filled"
            >
              Realizar cierre
            </button> */}
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
